<div class="form-group" *ngFor="let customer of membership.all_customers">
  <label *ngIf="membership.is_group">{{ customer.first_name }} {{ customer.last_name }}</label>
  <div class="form-check" *ngFor="let addOn of membership.customer_add_on_options">
    <input class="form-check-input" type="checkbox"
           id="add-on-input-{{ customer.id.toString() }}-{{ addOn.id }}"
           [checked]="addOnIsSelectedForCustomer(customer, addOn)"
           (change)="toggleAddOnForCustomer(customer, addOn)">
    <label class="form-check-label"
           for="add-on-input-{{ customer.id.toString() }}-{{ addOn.id }}">
      {{ addOn.name }} ({{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }})
    </label>
  </div>
</div>

<p>
  Current fee total: <b>{{ orgConfig.formatCurrency(initialAddOnFeeTotal) }}</b>
  <br>
  New fee total: <b>{{ orgConfig.formatCurrency(getNewFeeTotal()) }}</b>
</p>

<p>
  Total cost of change:
  <b *ngIf="selectedAddOnChangeLoading">Loading...</b>
  <b *ngIf="!selectedAddOnChangeLoading">{{ orgConfig.getCurrencySymbol() }}{{ selectedAddOnChangeFee.fee_amount }}</b>
</p>

<div class="alert alert-warning" role="alert" *ngIf="mustDisplayMinimumChargeWarning()">
  This cost is less than your payment processor's minimum charge, so the change will be applied for free.
</div>

<p>
  The add-ons will take effect immediately.
</p>

<div class="alert alert-info" role="alert">
  If the new add-on fee amount is greater than the old amount, the customer will be charged the difference, pro-rated to the remaining time on the
  <span *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
    current billing cycle.
  </span>
  <span *ngIf="membership.purchase_type !== MembershipPurchaseType.recurring">
    membership.
  </span>
  No refund will be given if the new amount is less than the old amount.
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
